import { Role } from 'const/common';
import { includes } from 'lodash';
import { User } from '../app/pages/UserPage/type';

export const checkActive = (auth?: User | null, nameScreen?: string) => {
  if (auth?.role === Role.SUPER_ADMIN || auth?.role === Role.ADMIN) return true;
  if (!auth?.viewAccess || !nameScreen) return false;
  return includes(auth.viewAccess, nameScreen);
};
